import { LineChartPosition } from './types';

export const calculatePosition = (value: number, min: number, max: number, elementWidth: number) => {
  return (elementWidth * (value - min)) / (max - min) || 0;
};

export const calculateBlockPosition = (position: number, offset: number, limit: number, elementSize: number) => {
  return Math.min(Math.max(offset, position - elementSize / 2), limit);
};

export const calculateBottomLinePosition = (position: number, formattedPosition: number, width: number) => {
  const bottomBlockLinePosition = formattedPosition + width / 2;
  return calculateLinePosition(position, bottomBlockLinePosition);
};

export const calculateLinePosition = (start: number, end: number) => {
  const lineStart = Math.min(start, end);
  const lineWidth = Math.max(start, end) - lineStart;
  return { lineStart, lineWidth };
};

export const sortPositions = (positions: LineChartPosition[]): LineChartPosition[] => {
  return positions.sort((a, b) => a.position - b.position);
};
